import React, { Component } from 'react';

import APIHandler from 'config/APIHandler';
import DataHandler from 'config/DataHandler';

import ContactCard from 'views/ContactView/ContactCard';


export default class ContactView extends Component {
  constructor(props) {
    super(props);

    this.state = {
      contacts: [],
    };
  }

  componentDidMount() {
    this.loadContacts();
  }

  loadContacts() {
    DataHandler.matchAppId().then((appId) => {
      APIHandler.getContacts(appId).then((res) => {
        this.setState({ contacts: res.response });
      });
    });
  }

  render() {
    const { contacts } = this.state;
    console.log(contacts);
    return (
      <div className="contentContainer contact">
        <div className="contactView">
          {contacts.map((contact, index) => (
            <React.Fragment>
              {contact.country && contacts[index - 1].country !== contact.country && <div className="headerContact">{contact.country}</div>}
              {contact.name && (
                <div className="contactView__Card">
                  <div className="contactView__Content__Card">
                    <ContactCard
                      name={contact.name}
                      title={contact.title}
                      address={contact.address}
                      avatar={contact.avatar}
                      options={contact.options}
                      mail={contact}
                      appId={appId}
                      imageUrl={contact.image}
                      telephone={contact.phone}
                      website={contact.website}
                      other={contact.other_copy}
                      town={contact.address}
                    />
                  </div>
                </div>
              )}
            </React.Fragment>
          ))}
        </div>
      </div>
    );
  }
}
